<script>
    import Attribute from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/tab/Attribute.svelte?1733898724711';
    import { attribute_exists, get_label } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/tab/attribute_helper.js?1733898724711';

    export let product;
    export let attribute;

    $: exists = attribute_exists(product, attribute);
    $: attribute_label = get_label(product, attribute);
</script>

{#if exists}
    <tr>
        <th>{attribute_label}</th>
        <td><Attribute {product} {attribute} show_label={false} /></td>
    </tr>
{/if}
